"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.typography = exports.fontFamily = exports.fontWeight = void 0;
var breakpoints_1 = require("./breakpoints");
exports.fontWeight = {
    light: 300,
    normal: 400,
    bold: 700,
};
exports.fontFamily = ["Aeonik", "sans-serif"].join(", ");
var h1 = (_a = {
        fontSize: "2rem",
        fontFamily: exports.fontFamily,
        lineHeight: 1.25,
        fontWeight: exports.fontWeight.bold
    },
    _a["@media (min-width: " + breakpoints_1.breakpoints.values.sm + "px)"] = {
        fontSize: "3.5rem",
        lineHeight: 1.1,
    },
    _a);
var h2 = (_b = {
        fontSize: "1.5rem",
        fontFamily: exports.fontFamily,
        lineHeight: 1.3,
        fontWeight: exports.fontWeight.bold
    },
    _b["@media (min-width: " + breakpoints_1.breakpoints.values.sm + "px)"] = {
        fontSize: "2.5rem",
        lineHeight: 1.2,
    },
    _b);
var h3 = (_c = {
        fontSize: "1.25rem",
        fontFamily: exports.fontFamily,
        lineHeight: 1.4,
        fontWeight: exports.fontWeight.bold
    },
    _c["@media (min-width: " + breakpoints_1.breakpoints.values.sm + "px)"] = {
        fontSize: "1.5rem",
        lineHeight: 1.3,
    },
    _c);
var article = (_d = {
        fontSize: "1rem",
        fontFamily: exports.fontFamily,
        lineHeight: 1.5,
        fontWeight: exports.fontWeight.bold
    },
    _d["@media (min-width: " + breakpoints_1.breakpoints.values.sm + "px)"] = {
        fontSize: "1.25rem",
        lineHeight: 1.4,
    },
    _d);
exports.typography = {
    fontFamily: exports.fontFamily,
    fontWeightBold: exports.fontWeight.bold,
    h1: h1,
    h1Light: __assign(__assign({}, h1), { fontWeight: exports.fontWeight.light }),
    h2: h2,
    h2Light: __assign(__assign({}, h2), { fontWeight: exports.fontWeight.light }),
    h3: h3,
    h3Light: __assign(__assign({}, h3), { fontWeight: exports.fontWeight.light }),
    // Typography without variant defaults to body1
    body1: __assign(__assign({}, article), { fontWeight: exports.fontWeight.normal }),
    article: article,
    articleLight: __assign(__assign({}, article), { fontWeight: exports.fontWeight.normal }),
    regular16: {
        fontSize: "1rem",
        fontFamily: exports.fontFamily,
        lineHeight: 1.5,
        fontWeight: exports.fontWeight.normal,
    },
    regular14: {
        fontSize: "0.875rem",
        fontFamily: exports.fontFamily,
        lineHeight: 1.4,
        fontWeight: exports.fontWeight.normal,
    },
    regular12: {
        fontSize: "0.75rem",
        fontFamily: exports.fontFamily,
        lineHeight: 1.5,
        fontWeight: exports.fontWeight.normal,
    },
};
//# sourceMappingURL=typography.js.map